import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

const StickyStripe = ({
  navMenu,
  isShowIcon = true,
  stickyMenuItems = [],
  navbarRef,
  defaultActiveState,
}) => {
  const [activeSection, setActiveSection] = useState(defaultActiveState);

  const handleStickyScroll = (scrollToSection) => {
    const targetElement = document.getElementById(scrollToSection);
    setActiveSection(scrollToSection);

    // Scroll the page to the target section
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 190,
        behavior: "smooth",
      });
    }

    // Also scroll the clicked tab into view
    const stickyTab = document.getElementById(`sticky-tab-${scrollToSection}`);
    if (stickyTab) {
      stickyTab.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = navbarRef?.current?.offsetHeight || 0;
      const scrollPosition = window.scrollY + offset + 190;

      stickyMenuItems.forEach((sectionId) => {
        const targetElement = document.getElementById(sectionId.id);

        if (
          targetElement &&
          targetElement.offsetTop <= scrollPosition &&
          targetElement.offsetTop + targetElement.offsetHeight > scrollPosition
        ) {
          setActiveSection((prevSectionId) => {
            const newActiveSection =
              prevSectionId !== sectionId.id ? sectionId.id : prevSectionId;

            // Scroll the corresponding tab into view
            const stickyTab = document.getElementById(
              `sticky-tab-${sectionId.id}`
            );
            if (stickyTab) {
              stickyTab.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
              });
            }

            return newActiveSection;
          });
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [stickyMenuItems, navbarRef]);

  return (
    <li
      id={`sticky-tab-${navMenu.id}`}
      onClick={() => handleStickyScroll(navMenu.id)}
    >
      <div
        className={`pack-nav-wrap ${
          activeSection === navMenu.id ? "active" : ""
        }`}
      >
        {isShowIcon && <FontAwesomeIcon icon={navMenu.icon} />}
        {navMenu.label}
      </div>
    </li>
  );
};

export default StickyStripe;
